function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "targeting_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  className: "targeting_svg__a",
  transform: "translate(47 230)",
  d: "M0 0h16v16H0z"
})));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "targeting_svg__b"
}, /*#__PURE__*/React.createElement("path", {
  className: "targeting_svg__c",
  d: "M0 8a8 8 0 118 8 8.01 8.01 0 01-8-8zm1 0a7 7 0 107-7 7.008 7.008 0 00-7 7zm2 0a5 5 0 115 5 5.007 5.007 0 01-5-5zm1 0a4 4 0 104-4 4 4 0 00-4 4zm2 0a2 2 0 112 2 2 2 0 01-2-2zm1 0a1 1 0 101-1 1 1 0 00-1 1z"
}));

function SvgTargeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _ref, _ref2);
}

export default SvgTargeting;